export const formatSearch = (search) => {
  const { date_range, current_page, page_size, task_execute_record_id } = search
  const [startDate, endDate] = date_range || []
  return {
    page: {
      page_num: current_page,
      page_size,
    },
    begin_timestamp: startDate ? startDate.unix() : undefined,
    end_timestamp: endDate ? endDate.unix() : undefined,
    task_execute_record_id: task_execute_record_id || undefined,
    task_name: search?.task_name || undefined,
    cnick: search?.cnick || undefined,
  }
}
